/* eslint-disable */
import React from "react";
import {
  Home,
  Settings,
  Notification,
  Users,
  UserCircle,
  Calendar,
} from "tabler-icons-react";
import {
  IconBuildingSkyscraper,
  IconCalendarEvent,
  IconChristmasBall,
  IconCrown,
  IconHistory,
  IconLock,
  IconReport,
  IconReportAnalytics,
  IconReportSearch,
  IconSettings,
  IconUserCheck,
  IconUserEdit,
} from "@tabler/icons-react";

export interface NavItem {
  label: string;
  to: string;
  icon: React.ReactNode;
  permissionKey?: string | string[];
  allowedRoles?: string[];
  children?: NavItem[];
}

export const navConfig: NavItem[] = [
  {
    label: "Dashboard",
    to: "/attendance-dashboard",
    icon: <Home />,
    permissionKey: "dashboard",
    allowedRoles: ["admin", "member", "superadmin", "director", "supervisor"],
  },
  {
    label: "Employees",
    to: "",
    icon: <Users />,
    permissionKey: "employees",
    children: [
      {
        label: "Department",
        to: "/department",
        icon: <IconBuildingSkyscraper />,
        permissionKey: "employees.department",
      },
      {
        label: "All Employees",
        to: "/all-employees",
        icon: <IconUserEdit />,
        permissionKey: "employees.allEmployees",
      },
      {
        label: "Personal Leaves",
        to: "/leave-employees",
        icon: <IconUserCheck />,
        permissionKey: "employees.leaveEmployees",
      },
      {
        label: "Admin Leave",
        to: "/admin-leave",
        icon: <IconUserEdit />,
        permissionKey: "employees.adminLeave",
      },
      {
        label: "Attendance (Admin)",
        to: "/attendance-admin",
        icon: <IconUserCheck />,
        permissionKey: "attendance.admin",
      },
      {
        label: "Personal Attendence",
        to: "/attendance-employee",
        icon: <IconUserEdit />,
        permissionKey: "attendance.employee",
      },

      {
        label: "Leave Configuration",
        to: "/leave-configuration",
        icon: <IconSettings />,
        permissionKey: "employees.leaveConfiguration",
      },
    ],
  },
  {
    label: "Calendar",
    to: "/calendar",
    icon: <Calendar />,
    permissionKey: "dashboard",
    allowedRoles: ["admin", "member", "superadmin", "supervisor"],
  },
  {
    label: "Holidays",
    to: "/holiday",
    icon: <IconChristmasBall />,
    permissionKey: "holidays",
  },
  {
    label: "Reports",
    to: "",
    icon: <IconReportAnalytics />,
    permissionKey: "reports",
    children: [
      {
        label: "Leave Reports",
        to: "/leave-reports",
        icon: <IconReportSearch />,
        permissionKey: "reports.leaveReports",
      },
      {
        label: "Attendance Reports",
        to: "/attendance-reports",
        icon: <IconReport />,
        permissionKey: "reports.attendanceReports",
      },
      {
        label: "Leave balance report",
        to: "/leave-history",
        icon: <IconHistory />,
        permissionKey: "reports.leaveHistoryReport",
      },
    ],
  },
  {
    label: "Admin Settings",
    to: "/admin-settings",
    icon: <Settings />,
    permissionKey: "adminSettings",
  },
  {
    label: "Profile",
    to: "/user-profile",
    icon: <UserCircle />,
    permissionKey: "userProfile",
  },
  {
    label: "Notifications",
    to: "/notifications",
    icon: <Notification />,
    permissionKey: "notifications",
  },
  {
    label: "Notification Settings",
    to: "/notification-settings",
    icon: <Notification />,
    permissionKey: "notifications",
    allowedRoles: ["admin", "superadmin"],
  },
  // {
  //   label: "Attendance",
  //   to: "/attendance",
  //   icon: <IconCalendarEvent />,
  //   permissionKey: "attendance",
  //   children: [
  //     {
  //       label: "Attendance (Admin)",
  //       to: "/attendance-admin",
  //       icon: <IconUserCheck />,
  //       permissionKey: "attendance.admin",
  //     },
  //     {
  //       label: "Personal Attendence",
  //       to: "/attendance-employee",
  //       icon: <IconUserEdit />,
  //       permissionKey: "attendance.employee",
  //     },
  //   ],
  // },
  {
    label: "Permissions",
    to: "/users",
    icon: <IconLock />,
    permissionKey: "permission_management.view_user_permissions",
  },
  {
    label: "Super Admin Panel",
    to: "/superadmin-dashboard",
    icon: <IconCrown />,
    permissionKey: "superAdminPanel",
  },
];
